import { combineReducers } from '@reduxjs/toolkit';
import { sitesUiSlice } from '@features/PressView/sections/SitesMap/store/SitesUiReducer';
import { mastsUiSlice } from '@features/PressView/sections/SitesMap/store/MastsUiReducer';
import { pmZoneSitesReducer } from './entity/pmzoneSites/PMZoneSitesReducer';
import { pmZoneSitesUiSlice } from '@features/store/pmZoneSitesUiReducer';
import { preferencesReducer } from './entity/preferences/PreferencesReducer';
import { accountsReducer, userProfileReducer } from './library-stores';

const rootReducer = combineReducers({
  [userProfileReducer.slice.name]: userProfileReducer.slice.reducer,
  [accountsReducer.slice.name]: accountsReducer.slice.reducer,
  [sitesUiSlice.name]: sitesUiSlice.reducer,
  [mastsUiSlice.name]: mastsUiSlice.reducer,
  [pmZoneSitesUiSlice.name]: pmZoneSitesUiSlice.reducer,
  [preferencesReducer.slice.name]: preferencesReducer.slice.reducer,
  [pmZoneSitesReducer.slice.name]: pmZoneSitesReducer.slice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
